import React, { useCallback, useEffect, useMemo, useState } from 'react';
import styles from './index.module.scss';
import AppLayout from '../../layout/AppLayout';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import ACTION_TYPES from '../../store/actionTypes.constants';
import { useAllOffers } from '../../api/api.calls';
import {
  isObjectEmpty,
  formatAppliedFilters,
  getAppliedFiltersLabel,
} from '../../utils/common.utils';
import { get } from 'lodash';
import { clearFilters } from '../OffersPage/offers.actions';
import { useParsedUrlFilters, useUrlFilters } from '../OffersPage/offers.utils';
import { ctLogV2 } from '../../utils/cleverTapLogger.utils';
import { useIdHash, useNavigateRoute } from '../../hooks/custom.hooks';
import FilterCard from './FilterCard';
import { useEffectControlled } from '../../hooks/render.hooks';
// import FadeInSection from '../../wrapper/FadeInWrapper';

function Filters() {
  const { data = {} } = useAllOffers();
  const filters = useMemo(() => {
    return get(data, 'filters', {}) ?? {};
  }, [data]);
  const appliedFilters = useSelector(
    ({ appReducer }) => appReducer.appliedFilters,
    shallowEqual,
  );
  const tempAppliedFilters = useSelector(
    ({ appReducer }) => appReducer.tempAppliedFilters,
    shallowEqual,
  );
  const [activeFilter, setActiveFilter] = useState([]);
  const navigateRoute = useNavigateRoute();
  const dispatch = useDispatch();
  useEffect(() => {
    if (!isObjectEmpty(filters)) {
      dispatch({
        type: ACTION_TYPES.FILTERS,
        payload: filters,
      });
      setActiveFilter(Object.keys(filters)[0]);
    }
  }, [dispatch, filters]);

  const parsedFilters = useParsedUrlFilters();

  useEffectControlled(() => {
    if (!isObjectEmpty(parsedFilters) && isObjectEmpty(appliedFilters)) {
      dispatch({
        type: ACTION_TYPES.TEMP_APPLIED_FILTERS,
        payload: parsedFilters,
      });
    } else {
      dispatch({
        type: ACTION_TYPES.TEMP_APPLIED_FILTERS,
        payload: appliedFilters,
      });
    }
  }, []);

  useEffect(() => {
    if (!isObjectEmpty(parsedFilters) && isObjectEmpty(appliedFilters)) {
      dispatch({
        type: ACTION_TYPES.APPLIED_FILTERS,
        payload: parsedFilters,
      });
    }
  }, [appliedFilters, dispatch, parsedFilters]);

  const getDisplayText = (name = '') => {
    return name.replaceAll('_', ' ');
  };

  const filterData = useMemo(() => {
    return filters[activeFilter] ?? [];
  }, [activeFilter, filters]);

  const handleSelect = useCallback(
    (eleId) => {
      let activeFilters = Array.isArray(tempAppliedFilters[activeFilter])
        ? [...tempAppliedFilters[activeFilter]]
        : [];
      if (activeFilter !== 'platform' && activeFilter !== 'offer_value') {
        if (activeFilters.includes(eleId)) {
          activeFilters = activeFilters.filter((aEntry) => aEntry !== eleId);
        } else {
          activeFilters.push(eleId);
        }
      } else {
        activeFilters = activeFilter !== 'platform' ? [eleId] : eleId;
      }

      const payload = {
        ...tempAppliedFilters,
        [activeFilter]: activeFilters,
      };
      dispatch({
        type: ACTION_TYPES.TEMP_APPLIED_FILTERS,
        payload: payload,
      });
    },
    [activeFilter, tempAppliedFilters, dispatch],
  );

  const checkDisabled = (items = []) => {
    return items.map((entry) => {
      return {
        ...entry,
        enabled: appliedFilters.category?.includes(entry.primary_category_id),
      };
    });
  };

  const getUndisabled = (list = []) => {
    const entries = checkDisabled(list);
    const undisabled = entries.sort((a, b) => b.enabled - a.enabled);
    return undisabled?.length ? undisabled : list;
  };
  const searchParams = useUrlFilters();
  // const searchParamsInit = useUrlFilters({ initFilters: true });
  const { custId: cid } = useIdHash();
  return (
    <AppLayout
      restrictedHeight
      gobackAction={() => {
        navigateRoute({ nextPage: `/` });
      }}
      customHeader={() => {
        return (
          <div className={styles.filterHeader}>
            <div className={styles.left}>Apply Filter</div>
          </div>
        );
      }}
      customFooter={() => {
        return (
          <div className={styles.filterActions}>
            <button
              onClick={() => {
                dispatch(clearFilters());
                navigateRoute({ nextPage: '/offers' });
                localStorage.setItem('filterTypeText', '');
              }}
              className={styles.clear}
            >
              Clear All
            </button>
            <button
              onClick={() => {
                dispatch({
                  type: ACTION_TYPES.APPLIED_FILTERS,
                  payload: tempAppliedFilters,
                });
                navigateRoute({
                  nextPage: `/offers/?${searchParams.toString()}`,
                });
                localStorage.setItem('filterTypeText', 'normal_filter');
                ctLogV2({
                  eventName: 'Web_Filter_applied',
                  eventCategory: 'Offer Listing Page',
                  eventDescription: 'Offer Listing Page - Web Filter Applied',
                  customerId: cid,
                  extraData: {
                    Filter_selected:
                      formatAppliedFilters(appliedFilters, filters) || '',
                    filter_type: 'normal_filter',
                    filter_labels: getAppliedFiltersLabel(appliedFilters) || '',
                  },
                });
              }}
            >
              Apply
            </button>
          </div>
        );
      }}
    >
      {/* <FadeInSection> */}
      <div className={styles.filtersSection}>
        <div className={styles.left}>
          {Object.keys(filters).map((entry, index) => {
            const isActive = entry === activeFilter;
            // Removed platform as all offers displayed now
            if (entry === 'platform') return null;
            /*if (filters[entry].length > 0 || (typeof filters[entry] === 'object' && !Array.isArray(filters[entry]))) {
              const subKeys = Object.keys(filters[entry]);
              const hasItems = subKeys.some(subKey => Array.isArray(filters[entry][subKey]) && filters[entry][subKey].length > 0);
              if (filters[entry].length > 0 || hasItems) {
                return (
                  <div
                    className={styles.tab}
                    key={index}
                    onClick={() => setActiveFilter(entry)}
                    style={{
                      color: isActive ? '#f7f8fc' : '#f7f8fcb8',
                      background: isActive ? '#1c2b5a' : '#162143',
                      fontWeight: isActive ? 600 : 500,
                    }}
                  >
                    {getDisplayText(entry)}
                  </div>
                );
              }
            }*/

            if (Array.isArray(filters[entry]) && filters[entry].length > 0) {
              return (
                <div
                  className={styles.tab}
                  key={index}
                  onClick={() => setActiveFilter(entry)}
                  style={{
                    color: isActive ? '#f7f8fc' : '#f7f8fcb8',
                    background: isActive ? '#1c2b5a' : '#162143',
                    fontWeight: isActive ? 600 : 500,
                  }}
                >
                  {getDisplayText(entry)}
                </div>
              );
            } else if (
              typeof filters[entry] === 'object' &&
              filters[entry] !== null
            ) {
              // For object filters, check if any subkey has non-empty array
              const hasItems = Object.values(filters[entry]).some(
                (value) => Array.isArray(value) && value.length > 0,
              );

              if (hasItems) {
                return (
                  <div
                    className={styles.tab}
                    key={index}
                    onClick={() => setActiveFilter(entry)}
                    style={{
                      color: isActive ? '#f7f8fc' : '#f7f8fcb8',
                      background: isActive ? '#1c2b5a' : '#162143',
                      fontWeight: isActive ? 600 : 500,
                    }}
                  >
                    {getDisplayText(entry)}
                  </div>
                );
              }
            }
            return null;
          })}
        </div>
        <div className={styles.right}>
          {activeFilter === 'offer_value' ? (
            <div
              className={styles.catergoryHeader}
              style={{
                borderBottom: '1px solid #1c2b5a',
                paddingBottom: 8,
              }}
            >
              Calculated on the order value of Rs 1200.
            </div>
          ) : null}
          {Array.isArray(filterData)
            ? getUndisabled(filterData).map((entry, index) => {
                return (
                  <FilterCard
                    entry={entry}
                    key={index}
                    activeFilter={activeFilter}
                    handleSelect={handleSelect}
                  />
                );
              })
            : Object.keys(filterData).map((entry, index) => {
                return (
                  <div key={index}>
                    {filterData[entry]?.length ? (
                      <div className={styles.catergoryHeader}>
                        {getDisplayText(entry)}
                      </div>
                    ) : null}
                    <div className={styles.filterCards}>
                      {getUndisabled(filterData[entry]).map((card, index) => {
                        return (
                          <FilterCard
                            entry={card}
                            key={index}
                            activeFilter={activeFilter}
                            handleSelect={handleSelect}
                          />
                        );
                      })}
                    </div>
                  </div>
                );
              })}
        </div>
      </div>
      {/* </FadeInSection> */}
    </AppLayout>
  );
}

export default Filters;
